const addPrefix = (prefix) => (bool) => {
    if (bool) {
        return (name) => `${prefix}${name[0].toUpperCase()}${name.substring(1)}`;
    }

    return (name) => name;
};

export default addPrefix;
